import axios from "axios";
import React, {Component} from "react";
import FeatherIcon from 'feather-icons-react';
import Listprint from "../../Listprint";
import BorrowForm from "./BorrowForm";

class   Borrow extends Component{

    state = {
        isModal : false,
        formData : null,
        date_end : null,
        borrows : [],
    }

    componentDidMount(){
        this.getBorrows();
    }

    handleInputM = (e) => {
        this.getBorrows();
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    async getBorrows(){
        this.setState({ borrows : [] })
        var borrows = await axios.get('borrows');
        if(borrows.status === 200)
        {
            this.setState({borrows : borrows.data}) 
        }
    }

    showModal = (borrow = null) => {
        this.setState({
            isModal : !this.state.isModal,
            formData : borrow,
        })
        this.getBorrows();
    }

    handleInput = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

    delete = (borrow) =>{
        axios.delete("borrows/" + borrow).then((response) => {
            this.getBorrows()
        }).catch((error)=>{})
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    render(){
        var rows = [], columns = [
            {
                label: 'Livre',
                field: 'book',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Référence',
                field: 'reference',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Emplacement',
                field: 'spot',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Auteur',
                field: 'author',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Demandeur',
                field: 'user',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Date demande',
                field: 'date_start',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Date remise',
                field: 'date_end',
                sort: 'asc',
                width: 50
            },
            {
                label: '#',
                field: 'action',
                sort: 'asc',
                width: 50,
                class: 'table_action'
            },
        ];
        this.state.borrows.map((borrow) => {

            var author = "", nationality = "";
            borrow.book.authorbooks.map(authorbook => {
                author += authorbook.author.last_name + " " + authorbook.author.first_name + " , ";
                nationality += authorbook.author.nationality + " , ";
            });

            var date_start = new Date(borrow.date_start);
                date_start = date_start.getDate() + "-" + (date_start.getMonth()  + 1) + "-" + date_start.getFullYear();
            
            var date_end = new Date(borrow.date_end);
                date_end = date_end.getDate() + "-" + (date_end.getMonth()  + 1) + "-" + date_end.getFullYear();
                                                                
            rows.push({
                book : borrow.book.title,
                reference : borrow.book.spot.reference,
                spot : borrow.book.spot.spot,
                author : author,
                user : borrow.student ? borrow.student.matricule + " " + borrow.student.user.last_name + " " + borrow.student.user.family_name + " (élève)" : borrow.staff.matricule + " " + borrow.staff.user.last_name + " " + borrow.staff.user.first_name + " (Personnel)",
                date_start : date_start,
                date_end : date_end,
                action : 
                <span className="table_action">
                        {
                            this.handleCheck("Modifier emprunt") == true && (
                                <div className="widget-todo-item-action d-flex align-items-center">
                                    <FeatherIcon icon="edit-2" size="16" className='cursor-move text-primary' type="button" onClick={() => this.showModal(borrow)}></FeatherIcon>
                                </div>
                            )
                        }
                </span>
            })
        })
        return(
            <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h5 className="h5 font-monospace">Les emprunts des livres</h5>
                {
                    this.handleCheck("Ajouter emprunt") == true && (
                        <div className="btn-toolbar mb-2 mb-md-0">
                            <div className="btn-group me-2">
                                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.showModal(null)}><FeatherIcon icon="plus-circle" ></FeatherIcon></button>
                            </div>
                        </div>
                    )
                }
            </div>
            

            <div className="card shadow mb-2">
                <div className="card-body">
                    <div className="row overflow-auto mt-2">
                        {
                            rows.length > 0 && (
                                <Listprint columns={columns} rows={rows} title={"Les emprunts des livres"}/>
                            )
                        }
                    </div>
                </div>
            </div>

            <BorrowForm
                isModal={this.state.isModal} 
                formData={this.state.formData} 
                showModal={this.showModal}
            />

        </div>
        )
    }
}
export default Borrow;
